import { Experiment } from 'modules/domains/campaign';

export const getLatestExperiment = (experiments: Experiment[]) => {
  if (!experiments?.length) return null;
  const sortedExperiments = [...experiments].sort((a, b) => {
    return +new Date(b.createdAt) - +new Date(a.createdAt);
  });
  return sortedExperiments?.[0];
};
